module.exports = __webpack_public_path__ + "static/leader1-909a35af7e481f3946e4dca1519be27a.png";